import { Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useSelector, useDispatch } from "react-redux";

import { textFilter } from "utils/table";
import { useGetInsurancesQuery } from "app/store/insurance/api/insuranceApi";
import {
  setShowInsuranceModal,
  setIsProcessing,
  setIsUpdateOperation,
  setSelectedInsurance,
  setShowDeleteConfirmationModal,
} from "app/store/insurance/slice/insuranceSlice";

const useInsurances = () => {
  const {
    showInsuranceModal,
    isUpdateOperation,
    isProcessing,
    showDeleteConfirmationModal,
  } = useSelector((state) => state.insurance);
  const { data: insurances, isFetching } = useGetInsurancesQuery();
  const dispatch = useDispatch();

  const closeInsuranceModal = () => {
    dispatch(setShowInsuranceModal(false));
  };

  const handleAddInsurance = () => {
    dispatch(setIsUpdateOperation(false));
    dispatch(setSelectedInsurance(null));
    dispatch(setShowInsuranceModal(true));
  };

  const handleUpdateInsurance = (selectedInsurance) => {
    dispatch(setIsUpdateOperation(true));
    dispatch(setSelectedInsurance(selectedInsurance));
    dispatch(setShowInsuranceModal(true));
  };

  const handleDeleteInsurance = (selectedInsurance) => {
    dispatch(setSelectedInsurance(selectedInsurance));
    dispatch(setShowDeleteConfirmationModal(true));
  };

  const columns = [
    {
      header: "Insurance code",
      accessorKey: "insurance_code",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Payor ID",
      accessorKey: "payor_id",
      filterVariant: "text",
      filterFn: textFilter,
      size: 100,
    },
    {
      header: "Insurance Name",
      accessorKey: "payor_name",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Phone",
      accessorKey: "phone",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Street Address",
      accessorKey: "street",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "City",
      accessorKey: "city",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "State",
      accessorKey: "state",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Zip",
      accessorKey: "zip",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Actions",
      accessor: "actions",
      enableColumnFilter: false,
      enableSorting: false,
      size: 100,
      accessorFn: (rowData) => {
        return (
          <div>
            <Tooltip title={"Edit"}>
              <EditOutlinedIcon
                className="action-buttons__edit"
                style={{ color: "#757575" }}
                onClick={() => handleUpdateInsurance(rowData)}
              />
            </Tooltip>

            <Tooltip title={"Delete"}>
              <DeleteOutlinedIcon
                style={{ color: "#757575" }}
                className="action-buttons__edit ml-2"
                onClick={() => handleDeleteInsurance(rowData)}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return {
    columns,
    insurances,
    isFetching,
    showInsuranceModal,
    setShowInsuranceModal,
    isUpdateOperation,
    closeInsuranceModal,
    handleAddInsurance,
    handleUpdateInsurance,
    isProcessing,
    setIsProcessing,
    showDeleteConfirmationModal,
  };
};

export default useInsurances;
